import React, { Component, useState } from "react";
import { assessmentActions, questionsActions, userActions } from "../../../../_actions";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import { connect } from "react-redux";
import moment from "moment";
import PageTemplate from './ComponentReport/PageTemplate';
import RadarChart from './ComponentReport/RadarChart';
import DashboardUserLayout from "../../../AdminPanel/Dashboard/DashboardUserLayout"
import MileProfileFinder from './ComponentReport/MileProfileFinder';
import ProfileDetails from './ComponentReport/ProfileDetails';
import ProfileFinder from './ComponentReport/ProfileFinder';
import FourFlowProfiles from './ComponentReport/FourFlowProfiles';
import DimensionScores from './ComponentReport/DimensionScores';
import { MdOutlineArrowBack } from "react-icons/md";


class FlowProfileReport extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef();
    this.state = {
      crrSelectedEmp: {
        "name": "Team Overall",
        "emp_id": ""
      }
    };
  }

  componentDidMount() {
    this.props.dispatch(questionsActions.emptyReducer());
    let type = this.props.match.params.id;
    this.props.dispatch(assessmentActions.getUserProfileDetails());

    if (type === "admin") {
      this.props.dispatch(assessmentActions.getFlowProfileReport({ code: this.props.match.params.idx }, "admin"));
    } else {
      this.props.dispatch(assessmentActions.getFlowProfileReport({ code: this.props.match.params.idx }));
    }

  }


  exportPDFWithComponent = () => {
    if (this.pdfExportComponent.current) {
      this.pdfExportComponent.current.save();
    }
  };

  handleSelectEmployee = (value) => {
    let { onAssessmentByEmpID, teamName } = this.props;
    let emp_id = "";
    if (value && value.employeeId) {
      emp_id = value.employeeId;
    }
    if (value) {
      this.setState({ crrSelectedEmp: { "emp_id": value.employeeId, "name": value.name } });
    } else {
      this.setState({ crrSelectedEmp: { "emp_id": "", "name": "Team Overall" } });
    }
    onAssessmentByEmpID(emp_id);
  }

  goBack = () => {
    this.props.history.push(`/assessment/useroverview`);
  }


  render() {
    let { assessment, onLogout, switchToAdmin, openAIBot } = this.props;
    let { getUserProfileDetailsData, getFlowProfileReportData } = assessment;

    const getPeriod = () => {
      const hour = moment().hour(); // 0-23
      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: getUserProfileDetailsData?.name ?? "Sample",
      email: getUserProfileDetailsData?.email ?? "",
      period: getPeriod()
    };

    let userName = userDetails?.name ?? "";

    let createdAt = moment()
      .utcOffset("+05:30")
      .format("DD MMMM, YYYY")
      ;



    let getCategory = (score) => {
      let obj = {
        LABEL: "",
        TEXTCOLOR: "",
        CLASSCOLOR: "",
        TEXT: "",
      }
      if (score >= 19 && score <= 25) {
        obj["LABEL"] = 'PRIMARY';
        obj["TEXTCOLOR"] = 'text-[#43A047]';
        obj["COLORCLASS"] = 'bg-[#43A047]/10 text-[#43A047] border-[#43A047]/30'
        obj["TEXT"] = 'Your dominant, most natural path into flow. Build your work, environment, and rituals around it.'
      } else if (score >= 13 && score <= 18) {
        obj["LABEL"] = 'SECONDARY';
        obj["TEXTCOLOR"] = 'text-[#1E88E5]';
        obj["COLORCLASS"] = 'bg-[#1E88E5]/10 text-[#1E88E5] border-[#1E88E5]/30'
        obj["TEXT"] = 'Your strong support profile. Lean on it when your primary route is blocked or unavailable.'
      } else if (score >= 7 && score <= 12) {
        obj["LABEL"] = 'TERTIARY';
        obj["TEXTCOLOR"] = 'text-[#FFA000]';
        obj["COLORCLASS"] = 'bg-[#FFA000]/10 text-[#FFA000] border-[#FFA000]/30'
        obj["TEXT"] = 'A situational mode you can access but do not default to.'
      } else if (score >= 0 && score <= 6) {
        obj["LABEL"] = 'LEAST USED';
        obj["TEXTCOLOR"] = 'text-[#E53935]';
        obj["COLORCLASS"] = 'bg-[#E53935]/10 text-[#E53935] border-[#E53935]/30'
        obj["TEXT"] = 'Untapped range - not a weakness. Deliberate practice here widens where you can find flow.'
      } else {
        obj["LABEL"] = 'N/A';
        obj["TEXTCOLOR"] = 'text-gray-400'
        obj["COLORCLASS"] = 'bg-gray-50 text-gray-700 border-gray-200'
        obj["TEXT"] = ''
      }
      return obj
    }

    function getColorCode(name, field) {

      const flowConfig = [
        {
          name: "Deep Thinker",
          barColor: "bg-sky-700",
          bgColor: "bg-sky-700/10",
          borderColor: "border-sky-700",
          scoreColor: "text-sky-800",
          textColor: "text-sky-700",
          description:
            "Your strongest natural flow path. You thrive in deep focus, complex thinking and independent work."
        },
        {
          name: "Hard Charger",
          barColor: "bg-rose-700",
          bgColor: "bg-rose-700/10",
          borderColor: "border-rose-700",
          scoreColor: "text-rose-800",
          textColor: "text-rose-700",
          description:
            "A high energy driver that fuels your performance. You rise to challenges and perform under pressure."
        },
        {
          name: "Flow Goer",
          barColor: "bg-teal-600",
          bgColor: "bg-teal-700/10",
          borderColor: "border-teal-600",
          scoreColor: "text-teal-700",
          textColor: "text-teal-700",
          description:
            "A natural strength that supports your interactions and amplifies your impact with others."
        },
        {
          name: "Crowd Pleaser",
          barColor: "bg-purple-700",
          bgColor: "bg-purple-700/10",
          borderColor: "border-purple-700",
          scoreColor: "text-purple-800",
          textColor: "text-purple-700",
          description:
            "Your least-used flow path. A growth opportunity to build versatility, spontaneity and adaptability."
        }
      ];


      return flowConfig?.find(obj => obj?.name === name)?.[field] ?? "";
    };



    console.log("getFlowProfileReportData------------------>", getFlowProfileReportData)

    let dataObj = {
      primaryName: getFlowProfileReportData?.primaryName ?? "",
      secondaryName: getFlowProfileReportData?.secondaryName ?? "",
      primaryScore: getFlowProfileReportData?.primaryScore ?? "",
      secondaryScore: getFlowProfileReportData?.secondaryScore ?? "",

      blendSummary: getFlowProfileReportData?.blendSummary?.summary ?? "",

      primaryBridgeWork:
        getFlowProfileReportData?.bridgeNormal
          ?.find(prev => prev?.name === getFlowProfileReportData?.primaryName)
          ?.workSummary ?? "",

      primaryBridgeRole:
        getFlowProfileReportData?.bridgeNormal
          ?.find(prev => prev?.name === getFlowProfileReportData?.primaryName)
          ?.roleSummary ?? [],



      secondaryBridgeWork:
        getFlowProfileReportData?.bridgeNormal
          ?.find(prev => prev?.name === getFlowProfileReportData?.secondaryName)
          ?.workSummary ?? "",

      secondaryBridgeRole:
        getFlowProfileReportData?.bridgeNormal
          ?.find(prev => prev?.name === getFlowProfileReportData?.secondaryName)
          ?.roleSummary ?? [],


      blendBridgeContent:
        getFlowProfileReportData?.bridgeBlend ?? "",


    }

    return (
      <DashboardUserLayout
        showBot={false}
        openAIBot={openAIBot}
        userDetails={userDetails}
        onLogout={onLogout}
        switchToAdmin={switchToAdmin}>


        <div className="sticky top-0 z-20 flex flex-col items-center justify-between gap-4 py-4 px-10 bg-white border-b md:flex-row"  >
          <div className="flex items-center space-x-3">
            <div className="bg-white hover:text-[#1976D2] text-gray-500 border border-[#D1D5DB] hover:border-[#1976D2] p-1.5 rounded-full cursor-pointer" onClick={() => this.goBack()}>
              <MdOutlineArrowBack size={26} className="inline-block" />
            </div>
            <h1 className="font-semibold md:text-xl text-lg line-clamp-1 text-[#3D405B]">Flow Profile Report</h1>
          </div>

          <div className='flex items-center space-x-4'>
            <button onClick={() => { this.exportPDFWithComponent(); }} className="flex-1 uppercase text-sm font-medium rounded-md flex items-center justify-center gap-2 px-5 py-3 cursor-pointer bg-[#2196f3] hover:bg-[#1976d2] text-white transition-all duration-200">
              <span className="material-symbols-outlined text-lg">file_download</span>Download Report</button>
          </div>
        </div>


        <div className='max-w-4xl mx-auto my-4 bg-white shadow-sm border min-h-screen flex flex-col justify-between'>
          <div className=''>
            <PDFExport ref={this.pdfExportComponent}
              pageTemplate={(pageObj) => <PageTemplate pageNum={pageObj.pageNum} />}
              scale={0.6}
              forcePageBreak=".page-break"
              paperSize="A4"
              margin={0}
              fileName={userName + ' - Flow Profile Report-' + createdAt}
              author="Pitstop Consultancy Pvt. Lts. Team"
              landscape={false}
            >

              <MileProfileFinder
                dataObj={dataObj}
                getColorCode={getColorCode}
                createdAt={createdAt} userName={userName} />


            </PDFExport>
          </div>
        </div>
      </DashboardUserLayout>
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment
  };
}

export default connect(mapStateToProps)(FlowProfileReport);